import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/pdfs.svg'
import _imports_1 from '@/assets/deleteIcon.svg'
import _imports_2 from '@/assets/sortBy.svg'
import _imports_3 from '@/assets/arrowRight.svg'
import _imports_4 from '@/assets/cancel.svg'
import _imports_5 from '@/assets/folderBrowseIcon.svg'


const _hoisted_1 = { class: "mb-5 mx-5 mt-3 ResponsiveControlePage" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "items-center justify-between flex" }
const _hoisted_4 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_5 = {
  key: 1,
  class: "title flex items-center"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "w-full minheight" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_22 = { class: "w-6/12" }
const _hoisted_23 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_24 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "w-6/12" }
const _hoisted_27 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_28 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_29 = { class: "w-6/12" }
const _hoisted_30 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_31 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_32 = { class: "flex flex-row mt-3" }
const _hoisted_33 = { class: "w-6/12" }
const _hoisted_34 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { class: "w-6/12" }
const _hoisted_37 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_38 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_39 = { class: "w-6/12" }
const _hoisted_40 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_41 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_42 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_43 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_44 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_45 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_46 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_47 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_48 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_49 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "mt-1 mb-4" }
const _hoisted_52 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_53 = {
  key: 2,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_54 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_55 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_56 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_57 = {
  key: 0,
  class: "flex mt-4 gap-4 flex-wrap"
}
const _hoisted_58 = { class: "pdf w-full rounded-sm" }
const _hoisted_59 = ["href"]
const _hoisted_60 = {
  key: 0,
  class: "text-xs ml-2"
}
const _hoisted_61 = {
  key: 1,
  class: "text-xs ml-1"
}
const _hoisted_62 = ["onClick"]
const _hoisted_63 = {
  key: 3,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_64 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_65 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_66 = { class: "comment-box w-full" }
const _hoisted_67 = { class: "my-3" }
const _hoisted_68 = {
  key: 0,
  class: "comments"
}
const _hoisted_69 = { class: "initials" }
const _hoisted_70 = { clas: "w-1/5" }
const _hoisted_71 = { class: "header" }
const _hoisted_72 = { class: "fontSize10PX" }
const _hoisted_73 = { class: "w-4/5 text-xs" }
const _hoisted_74 = {
  key: 4,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_75 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_76 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_77 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_78 = {
  key: 0,
  class: "initials"
}
const _hoisted_79 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_80 = {
  key: 2,
  class: "initials"
}
const _hoisted_81 = {
  key: 3,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_82 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_83 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_84 = {
  key: 6,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_85 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_86 = {
  key: 8,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_87 = {
  key: 5,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_88 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_89 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_90 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_91 = { class: "flex" }
const _hoisted_92 = {
  key: 0,
  class: "initials"
}
const _hoisted_93 = {
  key: 1,
  class: "initials"
}
const _hoisted_94 = { class: "logContainer w-93" }
const _hoisted_95 = { class: "flex mt-1" }
const _hoisted_96 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_97 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_98 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_99 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_100 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_101 = {
  key: 5,
  class: "font-semibold text-xs"
}
const _hoisted_102 = {
  key: 6,
  class: "font-semibold text-xs"
}
const _hoisted_103 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_104 = {
  key: 0,
  class: "flex"
}
const _hoisted_105 = { class: "text-xs w-full text-justify" }
const _hoisted_106 = {
  key: 1,
  class: "flex"
}
const _hoisted_107 = {
  key: 0,
  class: "font-normal text-xs ml-2"
}
const _hoisted_108 = {
  key: 1,
  class: "font-normal text-xs ml-2"
}
const _hoisted_109 = {
  key: 2,
  class: "font-normal text-xs ml-2"
}
const _hoisted_110 = {
  key: 3,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_111 = {
  key: 4,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_112 = {
  key: 5,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_113 = {
  key: 6,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_114 = {
  key: 7,
  class: "font-semibold text-xs"
}
const _hoisted_115 = {
  key: 8,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_116 = {
  key: 9,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_117 = {
  key: 10,
  class: "font-semibold text-xs"
}
const _hoisted_118 = {
  key: 2,
  class: "flex"
}
const _hoisted_119 = { class: "mx-2 text-xs" }
const _hoisted_120 = {
  key: 3,
  class: "flex"
}
const _hoisted_121 = { class: "mx-2 text-xs" }
const _hoisted_122 = {
  key: 4,
  class: "flex"
}
const _hoisted_123 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_124 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_125 = { class: "mx-2 text-xs text-justify" }
const _hoisted_126 = {
  key: 5,
  class: "flex items-center"
}
const _hoisted_127 = { class: "flex ml-4" }
const _hoisted_128 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_129 = { class: "m-3" }
const _hoisted_130 = { key: 0 }
const _hoisted_131 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_132 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_133 = { class: "flex flex-col mb-3" }
const _hoisted_134 = { key: 3 }
const _hoisted_135 = { class: "mb-3" }
const _hoisted_136 = { class: "mb-3" }
const _hoisted_137 = { class: "my-1" }
const _hoisted_138 = { class: "mb-3" }
const _hoisted_139 = ["disabled", "max"]
const _hoisted_140 = { class: "mb-3" }
const _hoisted_141 = ["disabled", "min"]
const _hoisted_142 = { class: "mb-3" }
const _hoisted_143 = ["min", "disabled"]
const _hoisted_144 = { class: "mb-3" }
const _hoisted_145 = { class: "mb-3" }
const _hoisted_146 = { class: "mb-3" }
const _hoisted_147 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_148 = { class: "relative w-full max-w-xl" }
const _hoisted_149 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_150 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_151 = { class: "impactcontainer popupbodycontainer flex-1 overflow-y-auto" }
const _hoisted_152 = { class: "formcontainer flex flex-col h-full" }
const _hoisted_153 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_154 = { class: "row flex flex-col mt-2" }
const _hoisted_155 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_156 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_157 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_158 = { class: "pt-3" }
const _hoisted_159 = {
  for: "upload",
  class: "cursor-pointer"
}
const _hoisted_160 = {
  key: 0,
  class: "text-sm text-mediumGrey heightForDiv"
}
const _hoisted_161 = {
  key: 1,
  class: "text-sm heightForDiv"
}
const _hoisted_162 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_163 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_164 = { class: "buttonposition flex justify-end items-center pt-4" }
const _hoisted_165 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_166 = { class: "popup-business flex-1 overflow-y-auto" }
const _hoisted_167 = { class: "flex flex-col h-full" }
const _hoisted_168 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_169 = { class: "statuscontainer px-5 pb-5" }
const _hoisted_170 = { class: "formcontainer flex flex-col" }
const _hoisted_171 = { class: "row flex flex-row upperspacing" }
const _hoisted_172 = { class: "w-1/2" }
const _hoisted_173 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_174 = {
  key: 0,
  class: "error-text"
}
const _hoisted_175 = { class: "row flex flex-row upperspacing" }
const _hoisted_176 = { class: "w-full" }
const _hoisted_177 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_178 = {
  key: 0,
  class: "error-text"
}
const _hoisted_179 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dotsloader = _resolveComponent("dotsloader")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!(_ctx.presentSubTask.TaskName))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", {
              class: _normalizeClass(_ctx.presentSubTask?.controlDetails != undefined && _ctx.presentSubTask?.presentSubTask?.controlDetails?.[0]?.controlTitle.length > 40 ? 'heading-ellipsis':'')
            }, _toDisplayString(_ctx.presentSubTask?.controlDetails?.[0]?.controlTitle||'N/A'), 3)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h1", {
              class: _normalizeClass(_ctx.presentSubTask.TaskName!=undefined && _ctx.presentSubTask.TaskName!='' && _ctx.presentSubTask.TaskName.length > 0 > 40? 'heading-ellipsis':'')
            }, _toDisplayString(_ctx.presentSubTask.TaskName), 3)
          ])),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.checkOwner() && (_ctx.presentSubTask.statusCode == 10415))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btnprimary mr-1.5",
                disabled: _ctx.clickOnButton,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrRejectTheParentApproval(10403)))
              }, "Approve", 8, _hoisted_8),
              _createElementVNode("button", {
                class: "btnprimary mr-1.5",
                disabled: _ctx.clickOnButton,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approveOrRejectTheParentApproval(10410)))
              }, "Reject", 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Tabs, {
                value: _ctx.selectedTabIndex,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
                scrollable: "",
                class: "w-80 heightFixing pr-5"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_TabList, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab, tabIndex) => {
                          return (_openBlock(), _createBlock(_component_Tab, {
                            key: tabIndex,
                            value: tab.id,
                            onClick: ($event: any) => (_ctx.toggleTabs(tab))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tab.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab, tabIndex) => {
                        return (_openBlock(), _createBlock(_component_TabPanel, {
                          key: tabIndex,
                          value: tab.id
                        }, {
                          default: _withCtx(() => [
                            (_ctx.dotsLoader == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_dotsloader)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (tab.id == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _cache[37] || (_cache[37] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "CID", -1)),
                                            ((_ctx.linkedControlDetails[0]?.clientUniqueId||'N/A'))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.linkedControlDetails[0]?.clientUniqueId ||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_21, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_22, [
                                            _cache[38] || (_cache[38] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Frequency", -1)),
                                            ((_ctx.presentSubTask?.controlFrequency||'N/A'))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.getControlFrequency(_ctx.presentSubTask?.controlFrequency)||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_24, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("div", _hoisted_26, [
                                            _cache[39] || (_cache[39] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Title", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlTitle))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.linkedControlDetails[0]?.controlTitle||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_28, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_29, [
                                            _cache[40] || (_cache[40] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Type", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlType))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.linkedControlDetails[0]?.controlType||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_31, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("div", _hoisted_33, [
                                            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                            (_ctx.linkedControlDetails[0]?.controlPriority && typeof _ctx.linkedControlDetails[0]?.controlPriority === 'number')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.linkedControlDetails[0]?.controlPriority)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.linkedControlDetails[0]?.controlPriority)])
                                                  }, _toDisplayString(_ctx.getProirityLabel(_ctx.linkedControlDetails[0]?.controlPriority)), 3)
                                                ], 2))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_34, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                          _createElementVNode("div", _hoisted_36, [
                                            _cache[42] || (_cache[42] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Class", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlClass))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.linkedControlDetails[0]?.controlClass||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_38, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_39, [
                                            _cache[43] || (_cache[43] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Family", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlFamily))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.linkedControlDetails[0]?.controlFamily||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_41, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[44] || (_cache[44] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Description", -1)),
                                          ((_ctx.linkedControlDetails[0]?.Description))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.linkedControlDetails[0]?.Description||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_43, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[45] || (_cache[45] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Policy/Procedure", -1)),
                                          ((_ctx.linkedControlDetails[0]?.controlPolicies))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.linkedControlDetails[0]?.controlPolicies||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_45, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[46] || (_cache[46] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Guidance", -1)),
                                          ((_ctx.linkedControlDetails[0]?.controlGuidance))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.linkedControlDetails[0]?.controlGuidance||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_47, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[47] || (_cache[47] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Task", -1)),
                                          ((_ctx.linkedControlDetails[0]?.controlMaintenanceTask))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.linkedControlDetails[0]?.controlMaintenanceTask||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_49, "N/A"))
                                        ]),
                                        (_ctx.presentSubTask.notes)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                              _createElementVNode("div", null, [
                                                _cache[48] || (_cache[48] = _createElementVNode("p", { class: "mt-2 mb-1 header" }, "Notes", -1)),
                                                _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.presentSubTask.notes), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [...(_cache[49] || (_cache[49] = [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between" }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "my-2 header" }, "Documents")
                                            ]),
                                            _createElementVNode("div", { class: "buttonposition flex justify-center items-center mb-1.5" })
                                          ])
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_54, [
                                            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "my-1 header" }, "Evidence")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_55, [
                                                _createElementVNode("div", _hoisted_56, [
                                                  _createElementVNode("button", {
                                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openFilePopup && _ctx.openFilePopup(...args))),
                                                    for: "upload",
                                                    class: _normalizeClass((_ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420)|| _ctx.isAddDisabled(10302)? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons')
                                                  }, "Attach", 2)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          (Object.keys(_ctx.presentSubTask).includes('evidences'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentSubTask.evidences, (doc, evidenceIndex) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: evidenceIndex }, [
                                                    _createElementVNode("div", _hoisted_58, [
                                                      _createElementVNode("a", {
                                                        href: _ctx.sanitizeUrl(doc.url),
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        class: "flex w-full flex-row items-center"
                                                      }, [
                                                        _cache[51] || (_cache[51] = _createElementVNode("img", {
                                                          src: _imports_0,
                                                          alt: ""
                                                        }, null, -1)),
                                                        (Object.keys(doc).includes('filename'))
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(doc.filename), 1))
                                                          : (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(doc.name), 1)),
                                                        _createElementVNode("img", {
                                                          src: _imports_1,
                                                          alt: "",
                                                          onClick: _withModifiers(($event: any) => (_ctx.removeEvidence(evidenceIndex)), ["stop","prevent"]),
                                                          class: _normalizeClass((_ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420)|| _ctx.isAddDisabled(10302)? 'h-5 w-5 pointer-events-none ml-auto' : 'h-5 w-5 cursor-pointer ml-auto')
                                                        }, null, 10, _hoisted_62)
                                                      ], 8, _hoisted_59)
                                                    ])
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 5)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_64, [
                                            _cache[54] || (_cache[54] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "my-2.5 header" }, "Comments")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_65, [
                                                (!_ctx.oldComments)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: "btnprimary flex taskEditButtons",
                                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortComments()))
                                                    }, [...(_cache[52] || (_cache[52] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_2,
                                                        class: "h-3 mr-2"
                                                      }, null, -1),
                                                      _createTextVNode(" Newest ", -1)
                                                    ]))]))
                                                  : _createCommentVNode("", true),
                                                (_ctx.oldComments)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      class: "btnprimary flex taskEditButtons",
                                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortComments()))
                                                    }, [...(_cache[53] || (_cache[53] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_2,
                                                        class: "h-3 mr-2 rotate-180"
                                                      }, null, -1),
                                                      _createTextVNode(" Oldest ", -1)
                                                    ]))]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_66, [
                                              _createElementVNode("div", _hoisted_67, [
                                                (_ctx.TaskDetailsDropDown.taskStatus!=10403&&_ctx.TaskDetailsDropDown.taskStatus!=10401&&_ctx.TaskDetailsDropDown.taskStatus!=10420 && !_ctx.isAddDisabled(10302))
                                                  ? (_openBlock(), _createBlock(_component_commentsEditor, { key: 0 }))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            (Object.keys(_ctx.presentSubTask).includes('comments'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentSubTask.comments, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-2",
                                                      key: index
                                                    }, [
                                                      _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.extractInitials((obj.name) )), 1),
                                                      _createElementVNode("div", _hoisted_70, [
                                                        _createElementVNode("div", _hoisted_71, _toDisplayString((obj.name)), 1),
                                                        _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.formatTime( obj.createdAt )), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_73, [
                                                        _createVNode(_component_safeHtml, {
                                                          content: obj.comment
                                                        }, null, 8, ["content"])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, [
                                          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "header" }, "Approvals")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_76, [
                                              _createElementVNode("div", _hoisted_77, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openApprovalpopup())),
                                                  class: _normalizeClass(_ctx.presentSubTask.statusCode==10403 || _ctx.presentSubTask.statusCode==10415 || _ctx.presentSubTask.statusCode==10420|| _ctx.isAddApprovalDisabled(10302)?'approvalbtndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons')
                                                }, " Send Approval ", 2)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentSubTask.approvals, (approval, number) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: number,
                                              class: "bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full"
                                            }, [
                                              (approval.createdBy != undefined && !approval.updatedBy)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                : _createCommentVNode("", true),
                                              (approval.createdBy != undefined && !approval.updatedBy)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString((approval.name)), 1))
                                                : _createCommentVNode("", true),
                                              (approval.updatedBy != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                : _createCommentVNode("", true),
                                              (approval.updatedBy != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString((approval.name)), 1))
                                                : _createCommentVNode("", true),
                                              (approval.statusCode == 10401)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(' Requested an approval ')))
                                                : (approval.statusCode == 10410)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(' Rejected an approval ')))
                                                  : (approval.statusCode == 10403)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(' Approved an approval ')))
                                                    : _createCommentVNode("", true),
                                              (approval.createdAt != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.formatTime(approval.createdAt)), 1))
                                                : _createCommentVNode("", true),
                                              (approval.updatedAt != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.formatTime(approval.updatedAt)), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 6)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_88, [
                                            _cache[58] || (_cache[58] = _createElementVNode("div", { class: "flex items-center justify-between" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "History")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_89, [
                                                _createElementVNode("div", _hoisted_90, [
                                                  (!_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "btnprimary flex taskEditButtons",
                                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, [...(_cache[56] || (_cache[56] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_2,
                                                          class: "h-3 mr-2"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ", -1)
                                                      ]))]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "btnprimary flex taskEditButtons",
                                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, [...(_cache[57] || (_cache[57] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_2,
                                                          class: "h-3 mr-2 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ", -1)
                                                      ]))]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: work,
                                              class: "bg-white p-4 mb-0.5 border-lightgrey border-b w-full"
                                            }, [
                                              _createElementVNode("div", _hoisted_91, [
                                                (Object.keys(work).includes('createdBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(_ctx.extractInitials((work.name))), 1))
                                                  : _createCommentVNode("", true),
                                                (Object.keys(work).includes('updatedBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.extractInitials((work.name))), 1))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_94, [
                                                  _createElementVNode("div", _hoisted_95, [
                                                    (Object.keys(work).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString((work.name)), 1))
                                                      : (Object.keys(work).includes('updatedBy'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString((work.name)), 1))
                                                        : _createCommentVNode("", true),
                                                    (work.actionEntity == 10301)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString('Created the Task on')))
                                                      : (work.statusCode != undefined && work.statusCode == 10418)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString('Terminated the Task on')))
                                                        : (work.actionEntity == 10302)
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString('Updated the Task on')))
                                                          : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('createdAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                      : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('updatedAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_102, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (Object.keys(work).includes('additionalInfo'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                        (Object.keys(work.additionalInfo).includes('comment'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                              _cache[59] || (_cache[59] = _createElementVNode("p", { class: "font-semibold text-xs widthForCommentBox" }, _toDisplayString('Comment :'), -1)),
                                                              _createElementVNode("p", _hoisted_105, [
                                                                _createVNode(_component_safeHtml, {
                                                                  content: work.additionalInfo.comment
                                                                }, null, 8, ["content"])
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('dateId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                              _cache[60] || (_cache[60] = _createElementVNode("p", { class: "font-normal text-xs" }, _toDisplayString('Updated the '), -1)),
                                                              (work.additionalInfo.dateId==20606)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(' Completion Date from')))
                                                                : (work.additionalInfo.dateId==20604)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(' Start Date from')))
                                                                  : (work.additionalInfo.dateId==20605)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_109, _toDisplayString(' dueDate from')))
                                                                    : _createCommentVNode("", true),
                                                              (work.additionalInfo.previousCompletionDate!='' && work.additionalInfo.dateId==20606)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_110, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousCompletionDate)), 1))
                                                                : (work.additionalInfo.previousStartDate!='' && work.additionalInfo.dateId==20604)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_111, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousStartDate)), 1))
                                                                  : (work.additionalInfo.previousEndDate!='' && work.additionalInfo.dateId==20605)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_112, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousEndDate)), 1))
                                                                    : (_openBlock(), _createElementBlock("p", _hoisted_113, "N/A")),
                                                              _cache[61] || (_cache[61] = _createElementVNode("p", { class: "mx-2 font-normal text-xs" }, _toDisplayString('to'), -1)),
                                                              (work.additionalInfo.updatedCompletionDate!=''&& work.additionalInfo.dateId==20606)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_114, _toDisplayString(_ctx.formatDate(work.additionalInfo.updatedCompletionDate)), 1))
                                                                : (work.additionalInfo.updatedStartDate!=''&& work.additionalInfo.dateId==20604)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_115, _toDisplayString(_ctx.formatDate(work.additionalInfo?.updatedStartDate)), 1))
                                                                  : (work.additionalInfo.updatedEndDate!='' && work.additionalInfo.dateId==20605)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_116, _toDisplayString(_ctx.formatDate(work.additionalInfo?.updatedEndDate)), 1))
                                                                    : (_openBlock(), _createElementBlock("p", _hoisted_117, "N/A"))
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('filename'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                              _cache[62] || (_cache[62] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Uploaded the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_119, _toDisplayString(work.additionalInfo.filename), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('assignee'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                              _cache[63] || (_cache[63] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                              _createElementVNode("p", _hoisted_121, _toDisplayString((work.additionalInfo.name)), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('approver'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                                              (Object.keys(work.additionalInfo).includes('action') && work.additionalInfo.action==10301)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_123, _toDisplayString('Requested approval from -')))
                                                                : (!Object.keys(work).includes('action'))
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_124, _toDisplayString('Request approved By -')))
                                                                  : _createCommentVNode("", true),
                                                              _createElementVNode("p", _hoisted_125, _toDisplayString((work.additionalInfo.name)), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                              _cache[65] || (_cache[65] = _createElementVNode("div", null, [
                                                                _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Updated The Status :'))
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_127, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorTemplateBg(work.additionalInfo.previousStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorTemplateText(work.additionalInfo.previousStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                ], 2),
                                                                _cache[64] || (_cache[64] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                  _createElementVNode("img", { src: _imports_3 })
                                                                ], -1)),
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorTemplateBg(work.additionalInfo.updatedStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorTemplateText(work.additionalInfo.updatedStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                ], 2)
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("div", _hoisted_129, [
                  _cache[81] || (_cache[81] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                    _createElementVNode("h1", null, "Task Details")
                  ], -1)),
                  (_ctx.dotsLoader == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                        _createElementVNode("div", _hoisted_131, [
                          _createVNode(_component_dotsloader)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_132, [
                        _createElementVNode("div", _hoisted_133, [
                          _cache[66] || (_cache[66] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                          ((_ctx.presentSubTask.statusCode == 10403 ))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.changeBackground()),
                                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                }, _toDisplayString(_ctx.SubTaskStatus1.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														}).value), 35)
                              ], 2))
                            : ((_ctx.presentSubTask.statusCode == 10420 ))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.changeBackground()),
                                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                  }, _toDisplayString(_ctx.failed.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														}).value), 35)
                                ], 2))
                              : ((_ctx.presentSubTask.statusCode == 10415 ))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(_ctx.changeBackground()),
                                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                    }, _toDisplayString(_ctx.inreview.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														}).value), 35)
                                  ], 2))
                                : (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                    ((_ctx.presentSubTask.statusCode != 10402))
                                      ? (_openBlock(), _createBlock(_component_Select, {
                                          key: 0,
                                          modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                          options: _ctx.SubTaskStatus,
                                          disabled: _ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420 || _ctx.isAddDisabled(10302),
                                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                                          optionLabel: "value",
                                          optionValue: "id",
                                          class: _normalizeClass(["custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey", _ctx.changeBackground()])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"]))
                                      : (_openBlock(), _createBlock(_component_Select, {
                                          key: 1,
                                          modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                          options: _ctx.SubTaskStatus1,
                                          disabled: _ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420 || _ctx.isAddDisabled(10302),
                                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                                          optionLabel: "value",
                                          optionValue: "id",
                                          class: _normalizeClass(["custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey", _ctx.changeBackground()])
                                        }, null, 8, ["modelValue", "options", "disabled", "class"]))
                                  ]))
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", null, [
                            _cache[68] || (_cache[68] = _createElementVNode("label", { class: "controllabel" }, "Assigned To", -1)),
                            _createElementVNode("div", null, [
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.presentSubTask.assignee,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.presentSubTask.assignee) = $event)),
                                suggestions: _ctx.userOptions,
                                onComplete: _ctx.asyncFind,
                                onItemSelect: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateAssignedMember(_ctx.presentSubTask.assignee))),
                                disabled: _ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420 || _ctx.isAddDisabled(10302),
                                optionLabel: "label",
                                optionValue: "value",
                                placeholder: "Assigned-To",
                                class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
															'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
															'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
														}])
                              }, {
                                empty: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                  _createElementVNode("div", { class: "text-sm" }, [
                                    _createElementVNode("span", null, "No Members Found")
                                  ], -1)
                                ]))]),
                                _: 1
                              }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_136, [
                          _cache[69] || (_cache[69] = _createElementVNode("label", { class: "controllabel mb-2" }, "Created By", -1)),
                          _cache[70] || (_cache[70] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.getPersonName(_ctx.presentSubTask.createdBy)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_138, [
                          _createElementVNode("div", null, [
                            _cache[71] || (_cache[71] = _createElementVNode("label", { class: "controllabel" }, "Start Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.presentSubTask.startDate) = $event)),
                              class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                              onFocus: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403,
                              max: _ctx.presentSubTask.dueDate,
                              onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateDate(_ctx.presentSubTask.startDate,20604)))
                            }, null, 40, _hoisted_139), [
                              [_vModelText, _ctx.presentSubTask.startDate]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", null, [
                            _cache[72] || (_cache[72] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.presentSubTask.dueDate) = $event)),
                              class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                              onFocus: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403,
                              min: _ctx.presentSubTask.startDate,
                              onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateDate(_ctx.presentSubTask.dueDate,20605)))
                            }, null, 40, _hoisted_141), [
                              [_vModelText, _ctx.presentSubTask.dueDate]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_142, [
                          _cache[73] || (_cache[73] = _createElementVNode("label", { class: "controllabel mb-2" }, "Completion Date", -1)),
                          _cache[74] || (_cache[74] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.presentSubTask.completedAt) = $event)),
                            class: _normalizeClass(["mt-2", {'inputboxstylingForSelectAtPopup': _ctx.presentSubTask.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentSubTask.startDate !== ''}]),
                            onFocus: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            min: _ctx.presentSubTask.startDate,
                            placeholder: "Select Date",
                            disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403,
                            onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.updateCompletionDate(_ctx.presentSubTask.completedAt)))
                          }, null, 42, _hoisted_143), [
                            [_vModelText, _ctx.presentSubTask.completedAt]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_144, [
                          _cache[75] || (_cache[75] = _createElementVNode("label", { class: "controllabel mb-2" }, "Team", -1)),
                          _cache[76] || (_cache[76] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.presentSubTask.departments), 1)
                        ]),
                        _createElementVNode("div", _hoisted_145, [
                          _cache[77] || (_cache[77] = _createElementVNode("label", { class: "controllabel mb-2" }, "Tier", -1)),
                          _cache[78] || (_cache[78] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getTargetTitle(_ctx.presentSubTask)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_146, [
                          _cache[79] || (_cache[79] = _createElementVNode("label", { class: "controllabel mb-2" }, "Scope", -1)),
                          _cache[80] || (_cache[80] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getTargetInfo(_ctx.presentSubTask)), 1)
                        ])
                      ]))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.importpopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.importpopUp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("div", _hoisted_149, [
                  _createElementVNode("div", _hoisted_150, [
                    _cache[83] || (_cache[83] = _createElementVNode("h1", null, "Import files", -1)),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCancelIcon()))
                    }, [...(_cache[82] || (_cache[82] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))])
                  ]),
                  _cache[88] || (_cache[88] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("div", _hoisted_152, [
                      _createElementVNode("div", _hoisted_153, [
                        _createElementVNode("div", _hoisted_154, [
                          _createElementVNode("div", null, [
                            _cache[84] || (_cache[84] = _createElementVNode("label", { class: "controllabel" }, "File Name ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                              type: "text",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.inputFileName) = $event)),
                              placeholder: "Filename",
                              onInput: _cache[29] || (_cache[29] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.inputFileName,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.inputFileName.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                  (_ctx.v$.inputFileName.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_156, "Required"))
                                    : (_ctx.v$.inputFileName.required && _ctx.v$.inputFileName.restrictCharacters30.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_157, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_158, [
                            _cache[86] || (_cache[86] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["mt-2 w-auto evidenceHeight bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden", {'is-invalid':_ctx.v$.fileToUpload.$error}])
                            }, [
                              _createElementVNode("input", {
                                type: "file",
                                placeholder: "Choose a file to upload",
                                ref: "fileInput",
                                class: "hidden",
                                id: "upload",
                                onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                              }, null, 544),
                              _createElementVNode("label", _hoisted_159, [
                                _cache[85] || (_cache[85] = _createElementVNode("div", { class: "float-right text-white flex justify-center heightForDiv items-center w-9 bg-primary" }, [
                                  _createElementVNode("img", { src: _imports_5 })
                                ], -1)),
                                (_ctx.fileName == '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_160, _toDisplayString(_ctx.placeholder), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.fileName != '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_161, _toDisplayString(_ctx.fileName), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2)
                          ]),
                          (_ctx.v$.fileToUpload.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                (_ctx.v$.fileToUpload.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, "File upload is required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[87] || (_cache[87] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_164, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", (_ctx.inputFileName.length == 0) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                            onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                          }, "Save", 2)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showApprovalPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.showApprovalPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_165, [
              _cache[90] || (_cache[90] = _createElementVNode("h1", null, "Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onCrossbtn()))
              }, [...(_cache[89] || (_cache[89] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_166, [
              _createElementVNode("div", _hoisted_167, [
                _createElementVNode("div", _hoisted_168, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("div", _hoisted_171, [
                          _createElementVNode("div", _hoisted_172, [
                            _cache[91] || (_cache[91] = _createElementVNode("label", { class: "controllabel" }, "Name of the Authority", -1)),
                            _createElementVNode("div", null, [
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.taskObj.approver,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.taskObj.approver) = $event)),
                                suggestions: _ctx.authorityOptions,
                                onComplete: _ctx.asyncFind1,
                                optionLabel: "label",
                                optionValue: "value",
                                field: "label",
                                appendTo: "self",
                                forceSelection: false,
                                placeholder: "Assigned-To",
                                class: _normalizeClass(["p-inputtext-sm systemsstyling", {
													'p-invalid':  _ctx.v$.taskObj.approver.$error,
													'has-options': _ctx.authorityOptions && _ctx.authorityOptions.length > 0,
													'no-options': !_ctx.authorityOptions.length &&  _ctx.searchValue !== '',
												}])
                              }, null, 8, ["modelValue", "suggestions", "onComplete", "class"])
                            ]),
                            (_ctx.v$.taskObj.approver.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                  (_ctx.v$.taskObj.approver.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_174, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("div", _hoisted_176, [
                            _cache[92] || (_cache[92] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.taskObj.approvalComments.$error }]),
                              placeholder: "Comments",
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.taskObj.approvalComments) = $event))
                            }, null, 2), [
                              [
                                _vModelText,
                                _ctx.taskObj.approvalComments,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.taskObj.approvalComments.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                                  (_ctx.v$.taskObj.approvalComments.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_178, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[93] || (_cache[93] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_179, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary mr-1.5", (JSON.stringify(_ctx.taskObj) == JSON.stringify(_ctx.taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onCancelbtnAtApproval()))
                    }, "Reset", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary", (JSON.stringify(_ctx.taskObj) == JSON.stringify(_ctx.taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.clickOnSaveForApproval(_ctx.taskObj)))
                    }, "Save", 2)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}